'use strict';

var _includes = require('lodash/includes');

var _includes2 = _interopRequireDefault(_includes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = function (path, values) {
  return function () {
    values = Array.isArray(values) ? values : [values];
    return (0, _includes2.default)(values, this.get(path));
  };
}; /**
    * Similar to `pathEquals`, this sees if the value in a path is in an 
    * array of acceptable values. Similar to lodash's `_.includes`
    */